import { FC, memo } from 'react';

import OutsourcingContractSettingsPresenter from './OutsourcingContractSettingsPresenter';

const OutsourcingContractSettings: FC = memo(() => (
  <OutsourcingContractSettingsPresenter />
));

export default OutsourcingContractSettings;
